import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { theme } from '../styles/theme';
import { SharedLayoutUltimate } from '../components/layout/SharedLayoutUltimate';


const ContentSection = styled.div`
  padding: 120px 0 60px;
  min-height: calc(100vh - 300px);
`;

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 ${theme.spacing.xl};

  @media (max-width: ${theme.breakpoints.tablet}) {
    padding: 0 ${theme.spacing.md};
  }
`;


const PageTitle = styled.h1`
  text-align: center;
  margin-bottom: ${theme.spacing['2xl']};
  color: ${theme.colors.primary.dark};
`;

const LastUpdated = styled.p`
  text-align: center;
  color: ${theme.colors.neutral.grey};
  font-size: ${theme.typography.sizes.sm};
  margin-bottom: ${theme.spacing['2xl']};
`;

const Section = styled.section`
  margin-bottom: ${theme.spacing['2xl']};
`;

const SectionTitle = styled.h2`
  color: ${theme.colors.primary.dark};
  margin-bottom: ${theme.spacing.lg};
  font-size: ${theme.typography.sizes.xl};
`;

const Content = styled.div`
  line-height: 1.8;
  color: ${theme.colors.neutral.darkGrey};
  
  p {
    margin-bottom: ${theme.spacing.lg};
  }
  
  ul {
    margin-bottom: ${theme.spacing.lg};
    padding-left: ${theme.spacing.xl};
    
    li {
      margin-bottom: ${theme.spacing.sm};
    }
  }
  
  strong {
    font-weight: ${theme.typography.fontWeights.semibold};
    color: ${theme.colors.primary.dark};
  }
`;

export const PrivacyPolicy: React.FC = () => {
  return (
    <SharedLayoutUltimate>
      <ContentSection>
        <Container>
          <PageTitle>Privacy Policy</PageTitle>
          <LastUpdated>Last Updated: October 8, 2025</LastUpdated>
          
          <Content>
            <Section>
              <SectionTitle>Our Commitment</SectionTitle>
              <p>
                AnnuityAnswers.com respects your privacy. We collect only the information necessary to provide our educational tools and services.
              </p>
            </Section>

            <Section>
              <SectionTitle>Information We Collect</SectionTitle>
              <p>We may collect the following information when you use our forms:</p>
              <ul>
                <li>Name and contact information (phone, email)</li>
                <li>State of residence (for regulatory compliance)</li>
                <li>General financial information you choose to provide (age, investment amounts)</li>
                <li>Annuity preferences and goals</li>
              </ul>
              <p>
                <strong>We do NOT collect:</strong> Social Security numbers, bank account information, credit card numbers, or other sensitive financial data.
              </p>
            </Section>

            <Section>
              <SectionTitle>How We Use Your Information</SectionTitle>
              <p>Information you provide is used solely to:</p>
              <ul>
                <li>Generate educational reports about annuity options</li>
                <li>Contact you if you request a callback from a specialist</li>
                <li>Comply with insurance regulatory requirements</li>
              </ul>
            </Section>

            <Section>
              <SectionTitle>Information Sharing</SectionTitle>
              <p>
                <strong>We do not sell, rent, or trade your personal information.</strong> We will not share your information with third parties except:
              </p>
              <ul>
                <li>When required by law or regulatory authorities</li>
                <li>With licensed insurance professionals only if you explicitly request to be contacted</li>
                <li>To protect against fraud or illegal activity</li>
              </ul>
              <p>
                <strong>Mobile Phone Information:</strong> Your mobile phone number and any information collected via text messaging will not be shared with third parties or affiliates for marketing or promotional purposes.
              </p>
            </Section>

            <Section>
              <SectionTitle>Data Security</SectionTitle>
              <p>
                We use industry-standard security measures to protect your information. However, no internet transmission is completely secure. 
                We encourage you to use caution when providing personal information online.
              </p>
            </Section>

            <Section>
              <SectionTitle>Your Rights</SectionTitle>
              <p>You have the right to:</p>
              <ul>
                <li>Request information about what data we have collected</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your information</li>
                <li>Opt-out of communications</li>
              </ul>
            </Section>

            <Section>
              <SectionTitle>Educational Use Only</SectionTitle>
              <p>
                This website provides educational information only. It is not intended as investment advice or a recommendation to purchase any specific product. 
                Always consult with qualified financial and legal advisors before making investment decisions.
              </p>
            </Section>

            <Section>
              <SectionTitle>Changes to This Policy</SectionTitle>
              <p>
                We may update this Privacy Policy periodically. Changes will be posted on this page with an updated revision date.
              </p>
            </Section>

            <Section>
              <SectionTitle>Contact Us</SectionTitle>
              <p>
                If you have questions about this Privacy Policy or your information, please contact us at:
              </p>
              <p>
                Cap Averill II & Associates<br />
                <Link to="/contact" style={{ color: '#4D65FF', textDecoration: 'underline' }}>Contact Us</Link>
              </p>
            </Section>
          </Content>
        </Container>
      </ContentSection>
    </SharedLayoutUltimate>
  );
};